export default __webpack_public_path__ + "static/media/Ballroll_00054.28162fab.png";